import { graphql, useStaticQuery } from "gatsby"

const query = graphql`
  query HinduTemples {
		allHinduTemplesCsv(sort: {order: ASC, fields: english_name_I}) {
			edges {
				node {
					chinese_name_I
					chinese_name_II
					english_name_I
					english_name_II
					id
					latitude
					longitude
					established_year
					telephone_number
					full_address
          date_sketch_created
				}
			}
		}
	}
`

const useHinduTemplesData = () => {
  let {
    allHinduTemplesCsv: { edges }
  } = useStaticQuery(query)

  let data = edges.map(x => x.node)

  return data
}

export default useHinduTemplesData
